import React, { useEffect, useState } from "react";
import TagManager from 'react-gtm-module';
import {
  Switch,
  Route,
  Redirect,
  Link as RouterLink,
  useHistory,
  useLocation,
  withRouter
} from "react-router-dom";
import { connect } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import ServiceWorkerWrapper from "../components/serviceworkerwrapper.component";
import { ToastContainer, Slide, toast } from "react-toastify";
import SignInPage from "./pages/Authentication/SignInPage";
import Blank from "./pages/Pages/Blank";
import Spinner from "../components/spinner/spinner.component";
import { logoutUser, sendAppLink, loginFromWeb, toggleOverlay } from "../store/actions/authActionCreators";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import MUISlide from "@material-ui/core/Slide";
import queryString from "query-string";
import '../fonts/index.css';
import * as logger from '../logger';
import BackendError from './pages/BackendError';
import NotFound from './pages/NotFound';
import DesktopHome from "./pages/DesktopHome";
import { trackDwebEvent } from '../desktop/analytics';
import {
  getSubscriptionStatus
} from "../store/actions/paymentsActionCreator";
import { getFilteredConfig, toggleChatSupport, updateChatView } from "../store/actions/userActionCreators";
import AuthPage from "./components/Auth/Auth";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#f1f3f6"
  },
  "@global": {
    scrollBehavior: 'smooth',
    "*::-webkit-scrollbar": {
      width: "0.4em",
    },
    "*::-webkit-scrollbar-track": {
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "*::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,.1)",
      outline: "1px solid slategrey",
    },
  },
  deskTopContainer: {
    scrollBehavior: 'smooth',
    padding: 0,
    height: "100vh",
    overflow: "auto",
    width: '100%',
    maxWidth: '100%',
    // [theme.breakpoints.between("xs","sm")]: {
    //   visibility:'hidden'
    // },
    // [theme.breakpoints.between("sm",'md')]: {
    //   visibility:'hidden'
    // },
  }
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <MUISlide direction="up" ref={ref} {...props} />;
});
const hardRefresh = (value) => {
  /*let oldValue = localStorage.getItem("latest_dweb_version");
  if (typeof oldValue == "string") {
    if(oldValue != value){
      localStorage.setItem("latest_dweb_version",value)
      if (typeof window != "undefined" && typeof window.location != "undefined"){
        alert("hard refresh happening")
        window.location.reload(true)
      }else{
        alert("hard refresh not happening")
      }
    }
  }else{
    localStorage.setItem("latest_dweb_version",value)
    if (typeof window != "undefined" && typeof window.location != "undefined"){
      alert("no token hard refresh happening")
      window.location.reload(true)
    }
  }*/
}
const DesktopApp = ({ user, dispatchToggleChatSupport, dispatchChatView, dispatchToggleTripOverlay,
  dispatchLogoutAction, dispatchSendAppLink, dispatchGetSubscriptionStatusAction,
  dispatchLoginFromWeb, dispatchGetFilteredConfig }) => {
  let search = window.location.search;
  const values = queryString.parse(search);
  let mode = values["mode"];
  const classes = useStyles();
  const [path, setPath] = React.useState([
    "/user-profile",
    "/party-ledger",
    "/all-trucks",
    "/trip-ledger"
  ]);
  const [userInfo, setUserInfo] = useState({});
  const [loginFromTP, setLoginFromTP] = useState(false);
  let location = useLocation();
  let history = useHistory();
  let homeSubPath = ["/auth"];
  // let userInfo = JSON.parse(localStorage.getItem('USER_INFO'));
  const [toggleChatSupportValue, setToggleChatSupportValue] = React.useState(false);

  // Controlling display and hiding of kapture chat widget.
  if (user && !user.showChat) {

    // if (document.getElementsByClassName("fc-widget-normal") && document.getElementsByClassName("fc-widget-normal")[0]) {
    //   document.getElementsByClassName("fc-widget-normal")[0].style.display = 'none';
    // }

    if (document.getElementById("parent_kapchat_container")) {
      window.HideKapWidget();
    }

  } else if (user && user.showChat) {

    // if (document.getElementsByClassName("fc-widget-normal") && document.getElementsByClassName("fc-widget-normal")[0]) {
    //   document.getElementsByClassName("fc-widget-normal")[0].style.display = 'block';

    //   // document.getElementsByClassName("fc-widget-normal")[0].config.headerProperty.hideChatButton = true;

    // }
   
    const toggleFaqHolder = document.getElementsByClassName("toggle-faq-holder") && document.getElementsByClassName("toggle-faq-holder")[0] ? document.getElementsByClassName("toggle-faq-holder")[0] : "";

    if (document.getElementById("parent_kapchat_container") && !toggleFaqHolder) {
      window.ShowKapWidget();
    }
    
  }

  useEffect(() => {

    if (user && user.userInfo) {
      setUserInfo(user.userInfo)
    }

    if (user && user.userInfo && user.userInfo.role && user.userInfo.role == "USER") {
      trackDwebEvent("Dweb Invited User joined", {
        invited_user_name: user && user.userInfo && user.userInfo.name ? user.userInfo.name : "",
        invited_user_contact_number: user && user.userInfo && user.userInfo.contactNumber ? user.userInfo.contactNumber : "",
        invited_user_id: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : ""
      });
    }

  }, [user.userInfo]);


  useEffect(() => {
    let user = JSON.parse(localStorage.getItem('USER_INFO'));
    if (localStorage.getItem("CheckTripOverlay") === null && user && !user.isNewUser) {
      dispatchToggleTripOverlay();
    }
  }, [user.userInfo]);


  useEffect(() => {
    if (user.toggleChatSupport) {
      setToggleChatSupportValue(true);
    } else {
      setToggleChatSupportValue(false);
    }
  }, [user.toggleChatSupport])

  useEffect(() => {
    if (typeof window != 'undefined') {
      //window.location.reload();
    }
    const tagManagerArgs = {
      gtmId: 'GTM-KKQG858'
    }
    TagManager.initialize(tagManagerArgs);
    let userInfo = JSON.parse(localStorage.getItem("USER_INFO"));
    if (userInfo && userInfo.isLoggedIn) {

      const requestData = {
        filteredKeys: ["online_payments_config", "dwebSearchBebounceMs", "panRegex", "gstRegex", "pincodeRegex",
          "GST_STATE_LIST", "subscription", "coming_soon", "VehicleRegex", "event_tracking"]
      }

      dispatchGetFilteredConfig(
        requestData,
        (data) => {

          if (data && data.status && data.status.code === 200) {
            let config = data.response;
            let pre = config && config.subscription && config.subscription.enabled && config.subscription.enabled == 1 ? true : false;
            if (config) {
              hardRefresh(config.latest_dweb_version)
            }
            if (pre) {
              dispatchGetSubscriptionStatusAction(
                (res) => {
                  if (res && res.status && res.status.code === 200 && res.response) {
                    let status = res.response;
                    if (
                      (status && typeof status.isExpired != 'undefined' && status.isExpired) ||
                      (userInfo && typeof userInfo.isSubscriptionActive != 'undefined' && !userInfo.isSubscriptionActive)
                    ) {
                      if (userInfo && userInfo.userInfo && userInfo.userInfo.role !== "USER") {
                        goToPremium()
                      }
                    }
                  }
                },
                () => {
                })
            }
          }

        },
        () => {

        }
      )
    }

  }, []);

  const goToPremium = (data) => {
    // if (userInfo && userInfo.role && userInfo.role != "USER") {
    history.push({
      pathname: `/payments`,
      state: {
        id: 1,
        pageTitle: 'Premium'
      }
    });
    // }
  }


  return (
    <>
      <ServiceWorkerWrapper />
      <Spinner />
      <Container className={classes.deskTopContainer}>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar
          transition={Slide}
        />
        {(!user || !user.isLoggedIn) && (
          <Switch>
            <Route path="/auth" component={AuthPage} />
            <Route exact path="/404" component={NotFound} />
            <Route exact path="/500" component={BackendError} />
            <Route path='/external' component={SignInPage} />
            {/* <Route path='/external' component={() => { window.location = 'https://www.transportbook.in/'; return null;} }/> */}
            <Redirect to="/external" />
          </Switch>
        )}
        {user.isLoggedIn && (<Switch>
          <Route path="/auth" component={AuthPage} />
          <Route exact path="/404" component={NotFound} />
          <Route exact path="/500" component={BackendError} />
          <Route path='/external' component={Blank} />
          <Route path="/" component={DesktopHome} />
        </Switch>)}

        {/* {user.isLoggedIn && <div>
          <FreshChat
            token={freshChat}
            config={{
              headerProperty: {
                appName: 'TransportBook',
                appLogo: `https://dweb.transportbook.in/logo192.png`,
                backgroundColor: '#00875a',
                foregroundColor: '#FFFFFF',
                fontName: 'Roboto',
                fontUrl: 'https://fonts.googleapis.com/css?family=Roboto',
                // hideChatButton: toggleChatSupportValue
              }
            }}
            onInit={widget => {
              // Use `widget` instead of `window.fcWidget`
              // {
              //   toggleChatSupportValue &&
              //     widget.open()
              // }
              // widget.on("widget:closed", function (resp) {
              //   if (toggleChatSupportValue) {
              //     dispatchFreshChatView(false);
              //   }
              //   dispatchToggleChatSupport(false);
              //   //Function to do some task
              // });
              widget.user.setProperties({
                email: user && user.userInfo && user.userInfo.email ? user.userInfo.email : '',
                firstName: user && user.userInfo && user.userInfo.name ? user.userInfo.name : '',
                lastName: '',
                phone: user && user.userInfo && user.userInfo.contactNumber ? user.userInfo.contactNumber : '',
                externalId: user.userId ? user.userId : ''
              })
            }}
          />
        </div>} */}

      </Container>
    </>
  );
};
const DesktopAppWithRouter = withRouter(DesktopApp);
const mapStateToProps = (state) => ({ user: state.user });
const mapDispatchToProps = (dispatch) => ({
  dispatchLogoutAction: () => dispatch(logoutUser()),
  dispatchSendAppLink: (mobileNumber, onSuccess, onError) => dispatch(sendAppLink({ mobileNumber }, onSuccess, onError)),
  dispatchLoginFromWeb: (data, onSuccess, onError) => dispatch(loginFromWeb(data, onSuccess, onError)),
  dispatchGetSubscriptionStatusAction: (onSuccess, onFailure) => {
    dispatch(getSubscriptionStatus(onSuccess, onFailure))
  },
  dispatchToggleChatSupport: (value) => dispatch(toggleChatSupport(value)),
  dispatchChatView: (value) => dispatch(updateChatView(value)),
  dispatchToggleTripOverlay: () => {
    dispatch(toggleOverlay(true));
  },
  dispatchGetFilteredConfig: (data, onSuccess, onFailure) => {
    dispatch(getFilteredConfig(data, onSuccess, onFailure))
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(DesktopAppWithRouter);
